import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import {
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    Input,
    Checkbox,
    ListItemText,
    Button,
    ButtonGroup,
} from '@material-ui/core'

// styles
import useStyles from './styles'
import { isEmpty } from 'lodash'
import clsx from 'clsx'

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 10 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

export default function DataFilters(props) {
    const classes = useStyles()
    const countriesList = !isEmpty(props.filtersData) ? props.filtersData.countriesList : []
    const departmentsList = !isEmpty(props.filtersData) ? props.filtersData.departmentsList : []
    const jobFunctionsList = !isEmpty(props.filtersData) ? props.filtersData.jobFunctionsList : []
    const costCentersList = !isEmpty(props.filtersData) ? props.filtersData.costCentersList : []
    const filterTypes = ['Select by country', 'Select by department']
    const managersList = []

    const applyFilter = () => {
        props.onApply(props.componentName)
         if (props.setApplyFilters) {
            props.setApplyFilters(!props.applyFilters)
    }
}

    const resetFilter = () => {
        props.resetFilter(props.componentName)
        if (props.setApplyFilters) {
            props.setApplyFilters(!props.applyFilters)
        } 
    }

    // useEffect(() => {
    //     if(props.reportDataChanged[props.componentName]){
    //         props.onApply(props.componentName)
    //     }
    // }, [props])

    return (
        <React.Fragment>
            <div className={classes.filterContainer}>
                <ButtonGroup className={classes.filterButtonGroupHolder} color="primary">
                    <Button
                        className={
                            props.reportFiltersType === filterTypes[0]
                                ? classes.selectedFilterType
                                : classes.defaultFilterType
                        }
                        onClick={(e) => props.onDataFilterSelect('filterType', props.componentName, filterTypes[0])}
                    >
                        Filter by country
                    </Button>
                    <Button
                        className={
                            props.reportFiltersType === filterTypes[1]
                                ? classes.selectedFilterType
                                : classes.defaultFilterType
                        }
                        onClick={(e) => props.onDataFilterSelect('filterType', props.componentName, filterTypes[1])}
                    >
                        Filter by department
                    </Button>
                </ButtonGroup>
            </div>
            <div className={classes.filterContainer}>
                {
                    props.reportFiltersType === 'Select by country' ?
                        <React.Fragment>
                            {
								props.enabledFilters.indexOf('country') !== -1 ?
									<div className={classes.mainFilterContainer}>
										<FormControl className={clsx(classes.dataFieldformControl, classes.mainFilter)}>
											<InputLabel htmlFor="select-multiple-checkbox" shrink={true} className={classes.labelText}>
												Countries (Main Filter)
												<button className={classes.filterButton} onClick={(e) => {
													e.preventDefault()
													props.onDataFilterSelect('countries', props.componentName, countriesList)
												}
												}>Select All</button>
												<button className={classes.filterButton} onClick={(e) => {
													e.preventDefault()
													props.onDataFilterSelect('countries', props.componentName, [])
												}
												}>Clear</button>
											</InputLabel>
											<Select
												multiple
												value={props.reportFilters['dataFilters']['country']}
												onChange={(e) => props.onDataFilterSelect('country', props.componentName, e.target.value)}
												input={<Input id="select-multiple-countries" />}
												renderValue={selected => selected.join(',')}
												MenuProps={MenuProps}
												className={classes.filterText}
											>
												{countriesList.map(countryObj => (
													<MenuItem key={countryObj.country} value={countryObj.country}>
														<Checkbox color='primary' checked={props.reportFilters['dataFilters']['country'].indexOf(countryObj.country) > -1} />
														<ListItemText primary={countryObj.country} />
													</MenuItem>
												))}
											</Select>
										</FormControl>
									</div>
                                    :
                                    null
                            }

                            {
								props.enabledFilters.indexOf('department') !== -1 ?
                                    <FormControl className={clsx(classes.dataFieldformControl, classes.subFilter)}>
                                        <InputLabel htmlFor="select-multiple-checkbox" shrink={true} className={classes.labelText}>
                                            Departments (Sub Filter)
                                            <button className={classes.filterButton} onClick={(e) => {
                                                e.preventDefault()
                                                props.onDataFilterSelect('departments', props.componentName, departmentsList)
                                            }
                                            }>Select All</button>
                                            <button className={classes.filterButton} onClick={(e) => {
                                                e.preventDefault()
                                                props.onDataFilterSelect('departments', props.componentName, [])
                                            }
                                            }>Clear</button>
                                        </InputLabel>
                                        <Select
                                            multiple
                                            value={props.reportFilters['dataFilters']['department']}
                                            onChange={(e) => props.onDataFilterSelect('department', props.componentName, e.target.value)}
                                            input={<Input id="select-multiple-departments" />}
                                            renderValue={selected => selected.join(',')}
											MenuProps={MenuProps}
											className={classes.filterText}
                                        >
                                            {departmentsList.map(departmentObj => (
                                                <MenuItem key={departmentObj.department} value={departmentObj.department}>
                                                    <Checkbox color='primary' checked={props.reportFilters['dataFilters']['department'].indexOf(departmentObj.department) > -1} />
                                                    <ListItemText primary={departmentObj.department} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    :
                                    null
                            }
                        </React.Fragment>
                        :
                        <React.Fragment>
                            {
								props.enabledFilters.indexOf('department') !== -1 ?
									<div className={classes.mainFilterContainer}>
										<FormControl className={clsx(classes.dataFieldformControl, classes.mainFilter)}>
											<InputLabel htmlFor="select-multiple-checkbox" shrink={true} className={classes.labelText}>
												Departments (Main Filter)
												<button className={classes.filterButton} onClick={(e) => {
													e.preventDefault()
													props.onDataFilterSelect('departments', props.componentName, departmentsList)
												}
												}>Select All</button>
												<button className={classes.filterButton} onClick={(e) => {
													e.preventDefault()
													props.onDataFilterSelect('departments', props.componentName, [])
												}
												}>Clear</button>
											</InputLabel>
											<Select
												multiple
												value={props.reportFilters['dataFilters']['department']}
												onChange={(e) => props.onDataFilterSelect('department', props.componentName, e.target.value)}
												input={<Input id="select-multiple-departments" />}
												renderValue={selected => selected.join(',')}
												MenuProps={MenuProps}
												className={classes.filterText}
											>
												{departmentsList.map(departmentObj => (
													<MenuItem key={departmentObj.department} value={departmentObj.department}>
														<Checkbox color='primary' checked={props.reportFilters['dataFilters']['department'].indexOf(departmentObj.department) > -1} />
														<ListItemText primary={departmentObj.department} />
													</MenuItem>
												))}
											</Select>
										</FormControl>
									</div>
                                    :
                                    null
                            }
                            {
                                props.enabledFilters.indexOf('country') !== -1 ?
                                    <FormControl className={clsx(classes.dataFieldformControl, classes.subFilter)}>
                                        <InputLabel htmlFor="select-multiple-checkbox" shrink={true} className={classes.labelText}>
                                            Countries (Sub Filter)
                                            <button className={classes.filterButton} onClick={(e) => {
                                                e.preventDefault()
                                                props.onDataFilterSelect('countries', props.componentName, countriesList)
                                            }
                                            }>Select All</button>
                                            <button className={classes.filterButton} onClick={(e) => {
                                                e.preventDefault()
                                                props.onDataFilterSelect('countries', props.componentName, [])
                                            }
                                            }>Clear</button>
                                        </InputLabel>
                                        <Select
                                            multiple
                                            value={props.reportFilters['dataFilters']['country']}
                                            onChange={(e) => props.onDataFilterSelect('country', props.componentName, e.target.value)}
                                            input={<Input id="select-multiple-countries" />}
                                            renderValue={selected => selected.join(',')}
											MenuProps={MenuProps}
											className={classes.filterText}
                                        >
                                            {countriesList.map(countryObj => (
                                                <MenuItem key={countryObj.country} value={countryObj.country}>
                                                    <Checkbox color='primary' checked={props.reportFilters['dataFilters']['country'].indexOf(countryObj.country) > -1} />
                                                    <ListItemText primary={countryObj.country} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    :
                                    null
                            }
                        </React.Fragment>
                }
                {
                    props.enabledFilters.indexOf('jobFunction') !== -1 ?
                        <FormControl className={clsx(classes.dataFieldformControl, classes.subFilter)}>
                            <InputLabel htmlFor="select-multiple-checkbox" shrink={true} className={classes.labelText}>
                                Job Functions (Sub Filter)
                                <button className={classes.filterButton} onClick={(e) => {
                                    e.preventDefault()
                                    props.onDataFilterSelect('functions', props.componentName, jobFunctionsList)
                                }
                                }>Select All</button>
                                <button className={classes.filterButton} onClick={(e) => {
                                    e.preventDefault()
                                    props.onDataFilterSelect('functions', props.componentName, [])
                                }
                                }>Clear</button>
                            </InputLabel>
                            <Select
                                multiple
                                value={props.reportFilters['dataFilters']['function']}
                                onChange={(e) => props.onDataFilterSelect('function', props.componentName, e.target.value)}
                                input={<Input id="select-multiple-departments" />}
                                renderValue={selected => selected.join(',')}
								MenuProps={MenuProps}
								className={classes.filterText}
                            >
                                {jobFunctionsList.map(jobFunction => (
                                    <MenuItem key={jobFunction} value={jobFunction}>
                                        <Checkbox color='primary' checked={props.reportFilters['dataFilters']['function'].indexOf(jobFunction) > -1} />
                                        <ListItemText primary={jobFunction} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        :
                        null
                }

                {
                    props.enabledFilters.indexOf('manager') !== -1 ?
                        <FormControl className={clsx(classes.dataFieldformControl, classes.subFilter)}>
                            <InputLabel htmlFor="select-multiple-checkbox" shrink={true} className={classes.labelText}>Managers (Sub Filter)</InputLabel>
                            <Select
                                multiple
                                disabled
                                value={props.reportFilters['dataFilters']['manager']}
                                onChange={(e) => props.onDataFilterSelect('manager', props.componentName, e.target.value)}
                                input={<Input id="select-multiple-departments" />}
                                renderValue={selected => selected.join(',')}
								MenuProps={MenuProps}
								className={classes.filterText}
                            >
                                {managersList.map(manager => (
                                    <MenuItem key={manager.id} value={manager.name}>
                                        <Checkbox color='primary' checked={props.reportFilters['dataFilters']['manager'].filter(sm => sm.id === manager.id).length > 0} />
                                        <ListItemText primary={manager.name} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        :
                        null
                }

                {
                    props.enabledFilters.indexOf('costCenter') !== -1 && costCentersList.length !== 0 ?
                        <FormControl className={clsx(classes.dataFieldformControl, classes.subFilter)}>
                            <InputLabel htmlFor="select-multiple-checkbox" shrink={true} className={classes.labelText}>
                                Cost Center (Sub Filter)
                                <button className={classes.filterButton} onClick={(e) => {
                                    e.preventDefault()
                                    props.onDataFilterSelect('costcenters', props.componentName, costCentersList)
                                }
                                }>Select All</button>
                                <button className={classes.filterButton} onClick={(e) => {
                                    e.preventDefault()
                                    props.onDataFilterSelect('costcenters', props.componentName, [])
                                }
                                }>Clear</button>
                            </InputLabel>
                            <Select
                                multiple
                                value={props.reportFilters['dataFilters']['costCenter']}
                                onChange={(e) => props.onDataFilterSelect('costCenter', props.componentName, e.target.value)}
                                input={<Input id="select-multiple-costCenters" />}
                                renderValue={selected => selected.join(',')}
								MenuProps={MenuProps}
								className={classes.filterText}
                            >
                                {costCentersList.map(costCenter => (
                                    <MenuItem key={costCenter} value={costCenter}>
                                        <Checkbox color='primary' checked={props.reportFilters['dataFilters']['costCenter'].indexOf(costCenter) > -1} />
                                        <ListItemText primary={costCenter} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        :
                        null
                }

                <FormControl className={classes.buttonFormControl}>
                    <Button variant="contained" color="primary" className={classes.button} onClick={applyFilter}>
                        Apply
                </Button>
                    <Button color="secondary" onClick={resetFilter}>
                        Reset
                </Button>
                </FormControl>
            </div>
        </React.Fragment>
    )
}

DataFilters.propTypes = {
    onDataFilterSelect: PropTypes.func.isRequired,
    componentName: PropTypes.string.isRequired,
    reportFilters: PropTypes.object.isRequired,
    onApply: PropTypes.func.isRequired,
    enabledFilters: PropTypes.array,

}

DataFilters.defaultProps = {
    enabledFilters: ['country', 'department', 'jobFunction', 'costCenter'],
}
